export class DBSchema {
  public static USER_ROLE: string = `
        CREATE TABLE IF NOT EXISTS user_role (
            user_id INTEGER NOT NULL,
            user_role TEXT NOT NULL,
            tenant_id INTEGER NOT NULL,
            qbos_user_id INTEGER NOT NULL,
            PRIMARY KEY(user_id)
        )`;

  public static TEAM_ROLE: string = `
        CREATE TABLE IF NOT EXISTS team_role (
            tenant_id INTEGER NOT NULL,
            team_role TEXT NOT NULL,
            role_lookup_code TEXT NOT NULL,
            work_group TEXT NOT NULL
        )`;

  public static ASSESSMENT_TYPE: string = `
        CREATE TABLE IF NOT EXISTS assessment_type (
            tenant_id INTEGER NOT NULL,
            assessment_type_lookup_code TEXT NOT NULL,
            level_of_care_lookup_code TEXT NOT NULL,
            role_lookup_code TEXT NOT NULL
        )`;

  public static LOOKUP: string = `
        CREATE TABLE IF NOT EXISTS lookup (
            tenant_id INTEGER NOT NULL,
            lookup_code TEXT NOT NULL,
            lookup_type_code TEXT NOT NULL,
            lookup_value TEXT NOT NULL,
            lookup_value1 TEXT,
            description TEXT NOT NULL,
            sort_sequence INTEGER,
            is_default_visible BOOLEAN,
            lookup_reference_key TEXT
        )`;

  public static STATIC_DATA: string = `
        CREATE TABLE IF NOT EXISTS static_data (
            api_path TEXT NOT NULL,
            api_response TEXT,
            PRIMARY KEY(api_path)
        )`;

  public static ASSESSMENT: string = `
        CREATE TABLE IF NOT EXISTS assessments(
            id INTEGER NOT NULL,
            uuid TEXT NOT NULL,
	        pat_chart_id INTEGER,
            addendum BOOLEAN,
            asmt_status_lookup_code TEXT,
            asmt_status_lookup_value TEXT,
            asmt_type_lookup_code TEXT,
            asmt_type_lookup_value TEXT,
            care_plan_status_lookup_code TEXT,
            care_plan_status_lookup_value TEXT,
            coordinationOfCareAddendum BOOLEAN,
            duration TEXT,
            end_dte TEXT,
            performed_by TEXT,
            performed_by_id INTEGER,
            role_lookup_code TEXT,
            role_lookup_value TEXT,
            started_dte TEXT,
            timezone TEXT,
            created_date INTEGER,
            completed_date INTEGER,
            offline_insert INTEGER DEFAULT 0,
            PRIMARY KEY(id)
        )`;

  public static OFFLINE_ACTIONS: string = `
        CREATE TABLE IF NOT EXISTS offline_actions (
            action_id INTEGER PRIMARY KEY AUTOINCREMENT,
            assessment_id INTEGER,
            action TEXT,
            visit_type TEXT,
            asmt_type_lookup_code TEXT,
            role_lookup_code TEXT,
            payload TEXT,
            patient_id INTEGER,
            patient_name TEXT,
            expire_at INTEGER,
            updated_at INTEGER
        )`;

  public static PATIENT_DATA: string = `
        CREATE TABLE IF NOT EXISTS patient_data (
            chartId INTEGER NOT NULL,
            userId INTEGER,
            patientFullName TEXT,
            dateOfBirth TEXT,
            age INTEGER,
            primaryDiagnosis TEXT,
            secondaryDiagnosis TEXT, 
            levelOfCare TEXT, 
            codeStatus TEXT, 
            careTeam TEXT, 
            caseManagerFullName TEXT, 
            certifyingPhysicianFullame TEXT, 
            nursePractitioner TEXT, 
            attendingPhysicianFullName TEXT, 
            medicalDirectorFullName TEXT,
            careLocationType TEXT, 
            careLocationAddress1 TEXT, 
            careLocationCity TEXT, 
            careLocationState TEXT,
            careLocationZip TEXT, 
            primaryCareGiverFullName TEXT, 
            primaryCareGiverPhoneNumber TEXT, 
            riskPriority TEXT,
            patientGender TEXT,
            benefitPeriod INTEGER,
            foodAllergies TEXT,
            drugAllergies TEXT,
            dareStatus TEXT
        )`;

  public static TEMPLATE_REPLACEMENT_DATA: string = `
        CREATE TABLE IF NOT EXISTS template_replacement_data (
            patient_id INTEGER,
            family_contacts TEXT,
            lpn_contacts TEXT,
            hha_contacts TEXT,
            physician_contacts TEXT,
            PRIMARY KEY(patient_id)
        )`;

  public static LEVEL_OF_CARE: string = `
        CREATE TABLE IF NOT EXISTS level_of_care (
            level_of_care_lookup_code TEXT NOT NULL,
            level_of_care_code TEXT NOT NULL,
            level_of_care_value TEXT NOT NULL,
            PRIMARY KEY(level_of_care_lookup_code)
        )`;

  public static ASSESSMENT_DETAILS: string = `
        CREATE TABLE IF NOT EXISTS assessment_details (
            id INTEGER,
            uuid TEXT,
            tenant_id INTEGER,
            assessment_id INTEGER,
            pat_chart_id INTEGER,
            assessment_detail_id INTEGER,
            status_lookup_code TEXT,
            section_type_lookup_code TEXT,
            rec_type_lookup_code TEXT,
            data_json TEXT,
            level INTEGER,
            created_by INTEGER,
            created_date TEXT,
            updated_by INTEGER,
            updated_date TEXT,
            version INTEGER,
            active_flag TEXT
        )`;

  public static ASSESSMENT_TEMPLATE: string = `
        CREATE TABLE IF NOT EXISTS assessment_template (
            id INTEGER,
            uuid TEXT,
            tenant_id INTEGER,
            pat_chart_id INTEGER,
            assessment_id INTEGER,
            rec_type_lookup_code TEXT,
            tmpl_json TEXT,
            created_by INTEGER,
            created_date TEXT,
            updated_by INTEGER,
            updated_date TEXT,
            version INTEGER,
            active_flag TEXT
        )`;

  public static RULES_TEMPLATE: string = `
        CREATE TABLE IF NOT EXISTS rules_template (
            tenant_id INTEGER,
            tmpl_path TEXT,
            tmpl_json TEXT,
            asmt_type_lookup_code TEXT,
            role_lookup_code TEXT
        )`;

  public static ASSESSMENT_TEMPLATE_CONFIG: string = `
        CREATE TABLE IF NOT EXISTS assessment_template_config (
            tenant_id INTEGER,
            tmpl_version TEXT,
            tmpl_path TEXT,
            tmpl_json TEXT,
            asmt_type_lookup_code TEXT
        )`;

  public static ASSESSMENT_SECTION_TEMPLATE_CONFIG: string = `
        CREATE TABLE IF NOT EXISTS assessment_section_template_config (
            tenant_id INTEGER,
            tmpl_version TEXT,
            tmpl_path TEXT,
            tmpl_json TEXT,
            asmt_type_lookup_code TEXT,
            section_type_lookup_code TEXT
        )`;

  public static ASSESSMENT_SECTION_TYPE_ENUM: string = `
        CREATE TABLE IF NOT EXISTS assessment_section_type_enum (
            section_type TEXT,
            section_type_lookup_code TEXT,
            section_type_lookup_value TEXT,
            PRIMARY KEY(section_type_lookup_code)
        )`;

  public static PERMISSION_DICTIONARY: string = `
        CREATE TABLE IF NOT EXISTS permission_dictionary (
            group_id INTEGER,
            workgroup TEXT,
            access_lookup_code TEXT,
            access_lookup_value INTEGER
        )`;

  public static ASSESSMENT_VALIDATION: string = `
        CREATE TABLE IF NOT EXISTS assessment_validation (
            pat_chart_id INTEGER,
            admit_visit INTEGER,
            ica_visit TEXT,
            previouse_asmt TEXT,
            open_asmt INTEGER,
            patient_timezone TEXT
        )`;
}



// WEBPACK FOOTER //
// ./src/providers/offline-database/db-schema.ts